<template>
	<div class="inline-block" :class="wrap ? 'whitespace-normal' : 'whitespace-nowrap'">
		<span class="mr-4">{{ type == 'input' ? 'Typed:' : 'Pressed:' }}</span>
		<template v-for="(keystroke, index) in keys">
			<span
				v-if="isCombination(keystroke)"
				:key="`${index}-${keystroke}`"
				class="border rounded py-1 px-2 mx-2 text-gray-400 border-gray-500"
				:class="{'break-all': wrap}"
				>{{ convertCombination(keystroke) }}</span
			>
			<span
				v-else-if="specialKeys[keystroke]"
				:key="`${index}-${keystroke}`"
				class="border rounded py-1 px-2 mx-2 text-gray-400 border-gray-500"
				:class="{'break-all': wrap}"
				>{{ specialKeys[keystroke].toLowerCase() }}</span
			>
			<span
				v-else-if="punctuationKeys[keystroke]"
				:key="`${index}-${keystroke}`"
				class="text-gray-400 typed-background"
				style="width: 1em"
				:class="{'break-all': wrap}"
				>{{ punctuationKeys[keystroke] }}</span
			>
			<span
				v-else
				:key="`${index}-${keystroke}`"
				class="text-gray-200 typed-background"
				:class="{'break-all': wrap}"
				>{{ keystroke }}</span
			>
		</template>
		<ConsoleEventArg renderAs="ArgHtml" class="ml-6" :value="target" noInnerText :wrap="wrap" />
	</div>
</template>

<script>
import {keyCodeMapping} from 'shared/utils/keyCodeMapping'

export default {
	props: {
		target: {type: Object, required: true},
		type: {type: String, required: true},
		wrap: {type: Boolean, default: () => false},
		keys: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			specialKeys: {
				...keyCodeMapping,
				// add Spacebar if event is not input
				...(this.type != 'input' && {' ': 'Spacebar'}),
			},
			punctuationKeys: {
				' ': '·',
			},
		}
	},
	methods: {
		isCombination(keystroke) {
			return keystroke.includes('+')
		},
		convertCombination(keystroke) {
			return keystroke
				.split('+')
				.map(key => this.specialKeys[key] || key)
				.join(' + ')
				.toLowerCase()
		},
	},
}
</script>

<style scoped>
.typed-background {
	background: linear-gradient(120deg, var(--gray-600) 0%, var(--gray-600) 100%);
	background-repeat: no-repeat;
	background-size: 100% 100%;
	background-position: 0 100%;
}
</style>
